import React from "react";
import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { EnhancedTablePropsClips } from "./ClipsUtilities/clipsInterfaces";
import { visuallyHidden } from "@mui/utils";
import { AlertData, HeadCell } from "../Alerts/AlertsUtils/alertsInterfaces";

const headCells: readonly HeadCell[] = [
  {
    id: "file_id",
    numeric: true,
    label: "File ID",
  },
  // {
  //   id: "utc_time",
  //   numeric: false,
  //   label: "Received (UTC)",
  // },
  {
    id: "time",
    numeric: false,
    label: "Received (Local)",
  },
  {
    id: "site",
    numeric: false,
    label: "Site",
  },
  {
    id: "camera_name",
    numeric: false,
    label: "Camera Name",
  },
  {
    id: "probability",
    numeric: true,
    label: "Probability",
  },
  {
    id: "clip_result",
    numeric: false,
    label: "Clip Result",
  },
];

export const EnhancedSentinelTableHead = (props: EnhancedTablePropsClips) => {
  const { onRequestSort, orderBy, order } = props;
  const createSortHandler =
    (property: keyof AlertData) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              fontFamily: "mulish",
              fontWeight: 700,
              fontSize: 9,
              whiteSpace: "nowrap",
            }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              sx={{ whiteSpace: "nowrap" }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
